import React from "react";
import { Outlet } from "react-router-dom";

const CargoDocumentType: React.FC = () => {
  return <Outlet />;
};

export default CargoDocumentType;